import { CarouselAxis } from "./MovementAxis";

/**
 *
 */
export const DefaultOptionsCarousel = {
  movementAxis: CarouselAxis.X,
  loopItems: false,
  visibleItems: 1,
  spacing: 512,
  items: [],
  animateScale: true,
  animateAlpha: true
};
